import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {CompetitorResultsDetail, Race} from '@model';
import {getCompetitorDistance} from "@utility";

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'competitorSpeed',
    standalone: false
})
export class CompetitorSpeedPipe implements PipeTransform {

  transform(competitorResultsDetail?: CompetitorResultsDetail, race?: Race, dropUnit?: boolean): string {
    if (!competitorResultsDetail || !race || (!competitorResultsDetail.tl_tm && !competitorResultsDetail.tl_ch_tm)) {
      return '-';
    }

    const timeString = competitorResultsDetail.tl_ch_tm || competitorResultsDetail.tl_tm;
    /// ignore milliseconds, they are not needed for this calculation
    const hours = this.convertToHours(timeString!.split('.')[0]);
    let length = getCompetitorDistance(competitorResultsDetail, race);

    if (!length) {
      return '-';
    }
    length = length / 1000
    const speed = length / hours;
    return speed.toFixed(2) + (dropUnit ? '' : ' km/h');
  }

  private convertToHours(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours + minutes / 60 + seconds / 3600;
  }
}
